export default __webpack_public_path__ + "static/media/skybox.52527a46.png";